import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-voice-batch',
  templateUrl: './voice-batch.component.html',
  styleUrls: ['./voice-batch.component.scss']
})
export class VoiceBatchComponent implements OnInit {

  

  constructor() { }

  ngOnInit(){
    
  }

  

}
